export const tabStyle = {
  overflow: "visible",
  ".MuiTabs-indicator": {
    display: "none !important",
  },
  ".MuiTabs-scroller": {
    overflow: "visible !important",
  },
};
